import { ActionType, createAction } from "typesafe-actions";

import AccessChangeNotice from "@app/enum/AccessChangeNotice";
import AccessChangeOption from "@app/enum/AccessChangeOption";

// isOwnChange: the user's own save in this tab raised the version, e.g. an org rename
export const accessChanged = createAction("@accessChange/changed")<{ isOwnChange: boolean }>();

export const showAccessChangePrompt = createAction("@accessChange/showAccessChangePrompt")<void>();

export const chooseAccessChangeOption = createAction(
  "@accessChange/chooseAccessChangeOption"
)<AccessChangeOption>();

export const showAccessChangeNotice = createAction(
  "@accessChange/showAccessChangeNotice"
)<AccessChangeNotice>();

export const clearAccessChange = createAction("@accessChange/clearAccessChange")<void>();

export type Actions = ActionType<
  | typeof accessChanged
  | typeof chooseAccessChangeOption
  | typeof clearAccessChange
  | typeof showAccessChangeNotice
  | typeof showAccessChangePrompt
>;
